module.exports = __webpack_public_path__ + "fonts/text-security-disc-compat.99c1db9.ttf";